import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.bs{align-items:flex-start;}.ssr-plugin'
import '.f{gap:1.5rem;}.ssr-plugin'
import '.c7{background:var(--palette-white);}.ssr-plugin'
import '.a4{flex-direction:row;}.ssr-plugin'
import '.c5{justify-content:flex-start;}.ssr-plugin'
import '.gk{gap:2.5rem;}.ssr-plugin'
import '.bt{flex-wrap:wrap;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ap{gap:0.5rem;}.ssr-plugin'
import '.jp{font-size:4rem;}.ssr-plugin'
import '.dg{font-weight:700;}.ssr-plugin'
import '.jq{line-height:100%;}.ssr-plugin'
import '.ge{margin:0px;}.ssr-plugin'
import '.a5{color:var(--brand-secondary);}.ssr-plugin'
import '.a6{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="a b bs f c7"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="a a4 c5 bs gk bt"
      >
        {items.map((item, index) => (
          <div className="a b c ap"
            key={index}
          >
            <div className="jp dg jq ge a5 a6"
            >
              {item.total}
            </div>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
